import { AccessLevelEnum } from '@zaoblako/shared/modules/security/enums/access.level.enum';
import { CctvAccessRulesKeyEnum } from '@zaoblako/web/core/models/enums/access-rules/cctv/cctv-access-rules-key.enum';

type AccessRuleExpression = Record<string, any>;

export const CctvAccessRulesConst: Record<CctvAccessRulesKeyEnum, AccessRuleExpression> = {
  // --- Модуль CCTV (Системы видеонаблюдения) ---

  // --- Раздел CCTV.SECTIONS.PARKING (Парковка) ---
  [CctvAccessRulesKeyEnum.CCTV_PARKING_SETTINGS_READ]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PARKING.tabs.SETTINGS.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [CctvAccessRulesKeyEnum.CCTV_PARKING_SETTINGS_WRITE]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PARKING.tabs.SETTINGS.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [CctvAccessRulesKeyEnum.CCTV_PARKING_CAR_CATEGORY_READ]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PARKING.tabs.CAR_CATEGORY.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [CctvAccessRulesKeyEnum.CCTV_PARKING_CAR_CATEGORY_WRITE]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PARKING.tabs.CAR_CATEGORY.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [CctvAccessRulesKeyEnum.CCTV_PARKING_TRANSIT_TASK_READ]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PARKING.tabs.TRANSIT_TASK.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [CctvAccessRulesKeyEnum.CCTV_PARKING_TRANSIT_TASK_WRITE]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PARKING.tabs.TRANSIT_TASK.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [CctvAccessRulesKeyEnum.CCTV_PARKING_RESIDENT_CAR_READ]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PARKING.tabs.RESIDENT_CAR.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [CctvAccessRulesKeyEnum.CCTV_PARKING_RESIDENT_CAR_WRITE]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PARKING.tabs.RESIDENT_CAR.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [CctvAccessRulesKeyEnum.CCTV_PARKING_HIKVISION_CAMERA_READ]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PARKING.tabs.HIKVISION_CAMERA.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [CctvAccessRulesKeyEnum.CCTV_PARKING_HIKVISION_CAMERA_WRITE]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PARKING.tabs.HIKVISION_CAMERA.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },
  [CctvAccessRulesKeyEnum.CCTV_PARKING_REPORTS_READ]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PARKING.tabs.REPORTS.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [CctvAccessRulesKeyEnum.CCTV_PARKING_REPORTS_WRITE]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PARKING.tabs.REPORTS.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  // Разрешения (Парковка)
  [CctvAccessRulesKeyEnum.CCTV_PARKING_CAN_BLOCK_PARKING]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PARKING.permissions.CAN_BLOCK_PARKING.isAllowed': true
  },
  [CctvAccessRulesKeyEnum.CCTV_PARKING_CAN_DELETE_ACTIVE_TRANSIT_TASK]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PARKING.permissions.CAN_DELETE_ACTIVE_TRANSIT_TASK.isAllowed': true
  },
  [CctvAccessRulesKeyEnum.CCTV_PARKING_CAN_UNLINK_TRANSIT_TASK_EVENT]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PARKING.permissions.CAN_UNLINK_TRANSIT_TASK_EVENT.isAllowed': true
  },
  [CctvAccessRulesKeyEnum.CCTV_PARKING_ACCESS_TO_ALL_TRANSIT_TASK]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PARKING.permissions.ACCESS_TO_ALL_TRANSIT_TASK.isAllowed': true
  },
  [CctvAccessRulesKeyEnum.CCTV_PARKING_MANUAL_OPEN]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PARKING.permissions.MANUAL_OPEN.isAllowed': true
  },
  [CctvAccessRulesKeyEnum.CCTV_PARKING_EDIT_EVENT]: {
    'PHYSICAL_ACCESS_CONTROL.enabled': true,
    'PHYSICAL_ACCESS_CONTROL.sections.PARKING.permissions.EDIT_EVENT.isAllowed': true
  }
};
